import * as React from "react";
import { ExpandingButton } from "../../../shared/components/buttons/ExpandingButton";

interface Profile {
  id: number;
  [key: string]: any;
}

interface AddBlockCandidateProps {
  profile: Profile;
  job_id?: number;
  user_id?: number;
  favorited_init?: boolean;
  authenticity_token: string;
  blockedCallback?: () => void;
  expandDirection?: 'left' | 'right';
}

// Add Block API Function
const AddBlock = async ({ profile_id, authenticity_token, job_id, user_id }: {
  profile_id: number;
  authenticity_token: string;
  job_id?: number;
  user_id?: number;
}) => {
  const url = job_id
    ? `/profiles/${profile_id}/add_block_candidate/${job_id}`
    : `/profiles/${profile_id}/add_block_candidate_user/${user_id}`;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': authenticity_token
    },
  });

  const data = await response.json();
  return data.status.favorited;
};

// Remove Block API Function
const RemoveBlock = async ({ profile_id, authenticity_token, job_id, user_id }: {
  profile_id: number;
  authenticity_token: string;
  job_id?: number;
  user_id?: number;
}) => {
  const url = job_id
    ? `/profiles/${profile_id}/remove_block_candidate/${job_id}`
    : `/profiles/${profile_id}/remove_block_candidate_user/${user_id}`;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': authenticity_token
    },
  });

  const data = await response.json();
  return data.status.favorited;
};

// Main AddBlockCandidate Component
const AddBlockCandidate: React.FC<AddBlockCandidateProps> = ({
  profile,
  job_id,
  user_id,
  favorited_init = false,
  authenticity_token,
  blockedCallback = () => { },
  expandDirection = 'right',
}) => {
  const [state, setState] = React.useState({
    favorited: favorited_init,
    loading: false
  });

  const updateFavoriteState = (favorited: boolean) =>
    setState({
      favorited: favorited,
      loading: false
    });

  const RemoveFavoriteHandler = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setState({ ...state, loading: true });

    try {
      const result = await RemoveBlock({
        user_id,
        profile_id: profile.id,
        job_id: job_id,
        authenticity_token: authenticity_token,
      });
      updateFavoriteState(result);
    } catch (error) {
      console.error("Error removing block:", error);
      setState({ ...state, loading: false });
    }
  };

  const AddFavoriteHandler = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setState({ ...state, loading: true });

    try {
      const result = await AddBlock({
        user_id,
        profile_id: profile.id,
        job_id: job_id,
        authenticity_token: authenticity_token,
      });
      updateFavoriteState(result);
      blockedCallback();
    } catch (error) {
      console.error("Error adding block:", error);
      setState({ ...state, loading: false });
    }
  };

  return (
    <ExpandingButton
      icon="fad fa-ban"
      text={state.favorited ? "Blocked" : "Block"}
      variant="block"
      active={state.favorited}
      expandDirection={expandDirection}
      onClick={state.favorited ? RemoveFavoriteHandler : AddFavoriteHandler}
      title={state.favorited ? "Blocked from appearing in recommended candidates" : "Block from appearing in recommended candidates"}
    />
  );
};

export default AddBlockCandidate;